import { UserProfile } from '@dc-shared-web/hooks/api/user/types'
import { AxiosInstance } from 'axios'

type FetchUserProfileByIdParams = {
  userId: string
}

type FetchUserProfileById = (
  apiClient: AxiosInstance,
  params: FetchUserProfileByIdParams
) => Promise<UserProfile>

export const fetchUserProfileById: FetchUserProfileById = async (
  apiClient,
  { userId }
) => {
  const res = await apiClient.get(`/api/users/${userId}/profile`)

  return res.data
}
